export const getErrorMessage = (rawError) => {
  if (Object.keys(rawError).includes('non_field_errors')) {
    return rawError.non_field_errors;
  }
  return Object.keys(rawError).map((field) => {
    let key = field.charAt(0).toUpperCase() + field.slice(1);
    if (key === 'Errors') return rawError[field];
    if (key === 'Username') key = 'Email';
    return `${key}: ${rawError[field]}`;
  });
};

export default getErrorMessage;
